export const MAX_FIRST_NAME_LENGTH = 15
export const MAX_LAST_NAME_LENGTH = 20

export const USER_ROLES = {
  ADMIN: 'ADMIN',
  SUPPORT: 'SUPPORT',
  ALL: 'ALL',
}
